import { render, staticRenderFns } from "./LsFlowHeader.vue?vue&type=template&id=1a07b4d4&scoped=true&"
import script from "./LsFlowHeader.vue?vue&type=script&lang=js&"
export * from "./LsFlowHeader.vue?vue&type=script&lang=js&"
import style0 from "./LsFlowHeader.vue?vue&type=style&index=0&id=1a07b4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07b4d4",
  null
  
)

export default component.exports